export default function shebaIsNotVerified() {
  return this.$auth.user.publisher?.ibanStatus === 'F';
}
